export default {
  title: '合同信息',
  contractName: '合同名称',
  contractStatus: '合同状态',
  contractNum: '合同编号',
  contractType: '合同类型',
  contractTypePlaceholder: '请输入类型',
  contractPayType: '合同收支类型',
  contractAmount: '合同金额',
  contractAmountPlaceholder: '请输入金额',
  contractSignDate: '合同签订日期',
  contractEffectiveDate: '合同生效日期',
  contractEndDate: '合同结束日期',
  company: '甲方',
  employee: '乙方',
  pay: '付款',
  receive: '收款',
  upload: '上传文件',
  uploadFile: '上传合同',
  uploadTips: '请上传pdf文件，大小在60M以内',
  otherInfo: '其他信息',
  remark: '备注',
  remarkPlaceholder: '请输入备注',
  notaryPublic: '公证人',
  confirm: '确认提交',
  cancel: '取消',
};
